import { Component } from '@angular/core';
import { GridButton } from 'src/app/core/models/grid-button.model';
import { GridColumn } from 'src/app/core/models/grid-column.model';
import { GridFilter } from 'src/app/core/models/grid-filter.model';
import { GridSearchFilter } from 'src/app/core/models/grid-search-filter.model';
import moment from 'moment';

@Component({
    selector: 'app-product-groups',
    templateUrl: './product-groups.component.html',
    styleUrls: ['./product-groups.component.scss'],
    standalone: false
})
export class ProductGroupsComponent {

  buttons: GridButton[] = [
    {label: 'Edit', link: '/warehousing/product-groups/edit/:id', type: 'btn-warning',} as GridButton,
  ]

  columns: GridColumn[] = [
    {active: true, label: '#', field: 'id'} as GridColumn,
    {active: true, label: 'Name', field: 'name'} as GridColumn,
    {active: true, label: 'Code', field: 'code'} as GridColumn,
    {active: true, label: 'Description', field: 'description'} as GridColumn,
    {active: true, label: 'Created At', field: 'createdAt', value: v => moment(v).format('DD/MM/YYYY HH:mm:ss')} as GridColumn,
    {active: true, label: 'Updated At', field: 'updatedAt', value: v => moment(v).format('DD/MM/YYYY HH:mm:ss')} as GridColumn
  ];

  filters: GridFilter[] = []

  searchFields: any = ['name','code','description'];

  searchFilters: GridSearchFilter[] = [
    {
      field: 'name',
      label: 'Name',
    } as GridSearchFilter,
    {
      field: 'code',
      label: 'Code',
    } as GridSearchFilter,
    {
      field: 'description',
      label: 'Description',
    } as GridSearchFilter,
  ]
}
